// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from '../api/apiSlice'

  export const vehicleTrackingApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getVehicleTrackingList: builder.query<any, any>({
            query: params => {
                return {
                    url: `/rlog/list`,
                    params: params
                }
            },
            providesTags:['GetVehicleTrackingList'],
        }),
        getResultBlob: builder.mutation<any, any>({
          query: (params) => {
            const { id } = params
            return {
              url: `/rlog/resultblob/${id}`,
              method: "GET"
            }
          },
          invalidatesTags: ["GetVehicleTrackingBlob"],
        }),
  })
})

export const {
useGetVehicleTrackingListQuery,
useGetResultBlobMutation
} = vehicleTrackingApiSlice;